/* Keep first-screen images in HTML. Fetch other card images as they approach the
   viewport; clipped secondary slides load on swipe intent or when revealed. */
(function () {
  'use strict';
  var selector = 'img[data-rd-src]';
  var watched = new WeakSet();
  var revealed = new WeakSet();
  var fades = new Set();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('main img, .cart__image img').forEach(function (img) {
    if (img.complete && img.naturalWidth) revealed.add(img);
  });
  function reveal(event) {
    var img = event.target;
    if (!img.matches || !img.matches('main img, .cart__image img') || !img.naturalWidth || revealed.has(img)) return;
    revealed.add(img);
    if (reducedMotion.matches || !img.animate) return;
    var fade = img.animate([{ opacity: 0.25 }, { opacity: 1 }], {
      duration: 160,
      easing: 'ease-out'
    });
    if (!fade || !fade.addEventListener) return;
    fades.add(fade);
    function cleanup() { fades.delete(fade); }
    fade.addEventListener('finish', cleanup, { once: true });
    fade.addEventListener('cancel', cleanup, { once: true });
  }
  document.addEventListener('load', reveal, true);
  var onMotionChange = function () {
    if (reducedMotion.matches) fades.forEach(function (fade) { fade.cancel(); });
  };
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', onMotionChange);
  else if (reducedMotion.addListener) reducedMotion.addListener(onMotionChange);
  function load(img) {
    if (!img.hasAttribute('data-rd-src')) return;
    if (observer) observer.unobserve(img);
    var srcset = img.getAttribute('data-rd-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    img.setAttribute('src', img.getAttribute('data-rd-src'));
    img.removeAttribute('data-rd-src');
    img.removeAttribute('data-rd-srcset');
  }
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) { if (entry.isIntersecting) load(entry.target); });
  }, { rootMargin: '400px 0px', threshold: 0 }) : null;
  function watch(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    var imgs = Array.from(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) imgs.unshift(root);
    imgs.forEach(function (img) {
      if (watched.has(img)) return;
      watched.add(img);
      if (observer) observer.observe(img); else load(img);
    });
  }
  function intent(event) {
    var card = event.target.closest && event.target.closest('.grid-swipe, .product__photos');
    if (card) card.querySelectorAll(selector).forEach(load);
  }
  /* Product gallery. Every slide but the featured one ships as data-rd-src so the LCP image is
     alone on the wire, but a slide must never be blank when the gallery moves: a variant switch,
     a thumbnail, an arrow or a swipe selects a slide that IntersectionObserver only notices after
     it is already on screen (measured: ~1s blank on an 18-photo product). So
       1. the selected slide and its two neighbours load the moment Flickity marks it selected;
       2. once the page has loaded and the browser is idle, the rest of the gallery loads in
          order at low priority, so from then on every interaction is instant.
     Gallery slides sit far off to the side of the slider, outside the browser's lazy-load
     distance, so loading here also drops `loading="lazy"` or the fetch would never start. */
  function loadNow(img) {
    if (!img.hasAttribute('data-rd-src')) return;
    img.loading = 'eager';
    load(img);
  }
  function gallerySlides() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-product-photos] .product-main-slide'));
  }
  function loadSlide(slide, priority) {
    if (!slide) return;
    slide.querySelectorAll(selector).forEach(function (img) {
      if (priority) img.setAttribute('fetchpriority', priority);
      loadNow(img);
    });
  }
  function loadSelectedWithNeighbours() {
    var slides = gallerySlides();
    var i = -1;
    for (var k = 0; k < slides.length; k++) if (slides[k].classList.contains('is-selected')) { i = k; break; }
    if (i < 0) return;
    loadSlide(slides[i]);
    /* Neighbours at low priority: they must never race the featured (LCP) image. */
    loadSlide(slides[i - 1] || slides[slides.length - 1], 'low');
    loadSlide(slides[i + 1] || slides[0], 'low');
  }
  function prefetchGallery() {
    gallerySlides().forEach(function (slide) {
      slide.querySelectorAll(selector).forEach(function (img) {
        img.setAttribute('fetchpriority', 'low');
        loadNow(img);
      });
    });
  }
  function watchGallery() {
    var gallery = document.querySelector('[data-product-photos]');
    if (!gallery) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t.nodeType === 1 && t.classList.contains('is-selected')) { loadSelectedWithNeighbours(); return; }
      }
    }).observe(gallery, { attributes: true, attributeFilter: ['class'], subtree: true });
    loadSelectedWithNeighbours();
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1500); };
    var schedule = function () { idle(prefetchGallery, { timeout: 4000 }); };
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
  }
  function start() {
    watch(document);
    watchGallery();
    function animateLogos() {
      ['pointerdown', 'keydown', 'scroll'].forEach(function (event) {
        window.removeEventListener(event, animateLogos);
      });
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      document.querySelectorAll('img[data-motion-src]').forEach(function (img) {
        var src = img.getAttribute('data-motion-src');
        img.removeAttribute('data-motion-src');
        img.src = src;
      });
    }
    ['pointerdown', 'keydown', 'scroll'].forEach(function (event) {
      window.addEventListener(event, animateLogos, { passive: true });
    });
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) { mutation.addedNodes.forEach(watch); });
    }).observe(document.body, { childList: true, subtree: true });
    ['pointerdown', 'pointerover', 'focusin'].forEach(function (event) {
      document.addEventListener(event, intent, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
